export default __webpack_public_path__ + "static/netpoint-e3211e9f85a2f868285964ae977db410.svg";